export const TRANSCRIPT_DELIVERY_PREFERENCES = [
  "manual",
  "post_meeting_email",
  "forwarding_help",
] as const;

export type TranscriptDeliveryPreference = (typeof TRANSCRIPT_DELIVERY_PREFERENCES)[number];

export const DEFAULT_TRANSCRIPT_DELIVERY_PREFERENCE: TranscriptDeliveryPreference = "manual";
export const POST_MEETING_EMAIL_TRANSCRIPT_DELIVERY_PREFERENCE: TranscriptDeliveryPreference = "post_meeting_email";

export function isTranscriptDeliveryPreference(value: unknown): value is TranscriptDeliveryPreference {
  return (
    value === "manual" ||
    value === "post_meeting_email" ||
    value === "forwarding_help"
  );
}

export function resolveTranscriptDeliveryPreference(value: unknown): TranscriptDeliveryPreference {
  return isTranscriptDeliveryPreference(value) ? value : DEFAULT_TRANSCRIPT_DELIVERY_PREFERENCE;
}
